// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmailAddressOnGpiCompleteDialog_container__hv4aY","error-message":"ConfirmEmailAddressOnGpiCompleteDialog_error-message__vKD0q"};